export default __webpack_public_path__ + "static/sydney-opera-a55636126eb3f0b001813adb8a0f30af.jpg";